import { sb } from '../supabase.ts';

export async function renderActiveStudentUpdatePage(app: HTMLElement) {
  app.innerHTML = `
<style>
  .sync-wrap { background: #f1f5f9; height: 100vh; padding: 0; font-family: 'Inter', sans-serif; display: flex; flex-direction: column; }
  .sync-card { background: #fff; height: 100%; display: flex; flex-direction: column; border: none; border-radius: 0; box-shadow: none; overflow: hidden; }
  .sync-header { padding: 20px 32px; border-bottom: 1px solid #f1f5f9; flex-shrink: 0; display: flex; justify-content: space-between; align-items: center; }
  .sync-header h2 { font-size: 24px; font-weight: 800; color: #0f172a; margin: 0; }
  .sync-header p { font-size: 14px; color: #64748b; margin-top: 4px; }
  
  .stats-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; padding: 12px 32px; background: #f8fafc; border-bottom: 1px solid #f1f5f9; flex-shrink: 0; }
  .stat-item { background: #fff; padding: 12px; border-radius: 12px; border: 1px solid #e2e8f0; text-align: center; }
  .stat-label { font-size: 10px; font-weight: 700; color: #64748b; text-transform: uppercase; margin-bottom: 2px; }
  .stat-value { font-size: 18px; font-weight: 800; color: #0f172a; }

  .controls { padding: 16px 32px; background: #fff; border-bottom: 1px solid #f1f5f9; display: flex; gap: 16px; flex-wrap: wrap; align-items: flex-end; flex-shrink: 0; }
  .f-group { display: flex; flex-direction: column; gap: 6px; flex: 1; min-width: 160px; }
  .f-group label { font-size: 11px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.05em; }
  .f-group select, .f-group input { padding: 10px 14px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; background: #f8fafc; }
  
  .btn-load { background: var(--primary); color: #fff; border: none; padding: 10px 24px; border-radius: 10px; font-weight: 700; cursor: pointer; transition: 0.3s; height: 42px; }
  .btn-sync-all { background: #f59e0b; color: #fff; border: none; padding: 10px 24px; border-radius: 10px; font-weight: 700; cursor: pointer; transition: 0.3s; height: 42px; }

  .search-strip { padding: 12px 32px; background: #fff; border-bottom: 1px solid #f1f5f9; display: flex; gap: 20px; align-items: center; flex-shrink: 0; }
  .search-box { flex: 1; display: flex; align-items: center; gap: 8px; background: #f8fafc; padding: 8px 16px; border-radius: 10px; border: 1px solid #e2e8f0; }
  .search-box input { border: none; background: transparent; width: 100%; outline: none; font-size: 14px; }
  
  .checkbox-group { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: #475569; cursor: pointer; }

  .table-container { width: 100%; overflow: auto; flex-grow: 1; padding: 20px 32px; background: #f8fafc; }
  table { width: 100%; border-collapse: collapse; background: #fff; border-radius: 12px; overflow: hidden; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); }
  thead th { background: #f8fafc; padding: 16px; text-align: left; font-size: 12px; font-weight: 800; color: #475569; text-transform: uppercase; border-bottom: 2px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
  tbody td { padding: 16px; border-bottom: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; font-size: 15px; color: #1e293b; }
  thead th:last-child, tbody td:last-child { border-right: none; }
  
  .diff-chip { display: flex; flex-direction: column; gap: 4px; padding: 6px; background: #fff7ed; border-radius: 8px; border: 1px solid #ffedd5; }
  .old-val { font-size: 11px; color: #94a3b8; text-decoration: line-through; font-weight: 500; }
  .new-val { font-size: 15px; font-weight: 800; color: #ea580c; }
  .val-match { color: #10b981; font-weight: 700; font-size: 15px; display: flex; align-items: center; gap: 6px; }
  .val-match::before { content: '✓'; font-weight: 900; }

  .btn-sync { background: #6366f1; color: #fff; border: none; padding: 8px 16px; border-radius: 8px; font-size: 12px; font-weight: 700; cursor: pointer; transition: all 0.2s; box-shadow: 0 2px 4px rgba(99, 102, 241, 0.2); }
  .btn-sync:hover { background: #4f46e5; transform: translateY(-1px); box-shadow: 0 4px 6px rgba(99, 102, 241, 0.3); }
  .btn-sync:disabled { background: #f1f5f9; color: #94a3b8; cursor: not-allowed; }

  .loading-state { padding: 60px; text-align: center; color: #64748b; }
</style>

<div class="sync-wrap">
  <div class="sync-card">
    <div class="sync-header">
      <div>
        <h2>Active Status Sync</h2>
        <p>Maintain data consistency between Session and Active records</p>
      </div>
      <button class="btn-sync-all" id="syncAllBtn" style="display:none;">Sync All Discrepancies</button>
    </div>

    <div class="stats-row" id="statsRow" style="display:none;">
      <div class="stat-item">
        <div class="stat-label">Students Checked</div>
        <div class="stat-value" id="statChecked">0</div>
      </div>
      <div class="stat-item" style="border-color: #fef3c7;">
        <div class="stat-label" style="color: #d97706;">Mismatches Found</div>
        <div class="stat-value" style="color: #d97706;" id="statMismatch">0</div>
      </div>
      <div class="stat-item" style="border-color: #dcfce7;">
        <div class="stat-label" style="color: #10b981;">Fully Synced</div>
        <div class="stat-value" style="color: #10b981;" id="statSynced">0</div>
      </div>
    </div>

    <div class="controls">
      <div class="f-group">
        <label>Compare Against Session</label>
        <select id="sessionFilter">
          <option value="2025" selected>Session 2025</option>
          <option value="2026">Session 2026</option>
        </select>
      </div>
      <div class="f-group">
        <label>Filter by Class</label>
        <select id="classFilter">
          <option value="">All Classes</option>
          <option value="6">Class 6</option>
          <option value="7">Class 7</option>
          <option value="8">Class 8</option>
          <option value="9">Class 9</option>
          <option value="10">Class 10</option>
        </select>
      </div>
      <button class="btn-load" id="loadBtn">Run Comparison</button>
    </div>

    <div class="search-strip" id="searchStrip" style="display:none;">
      <div class="search-box">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
        <input type="text" id="tableSearch" placeholder="Search by name or IID...">
      </div>
      <label class="checkbox-group">
        <input type="checkbox" id="showOnlyMismatch">
        <span>Only Show Mismatches</span>
      </label>
    </div>

    <div class="table-container" id="comparisonTable">
      <div class="loading-state">
        <div style="font-size: 40px; margin-bottom: 12px;">🔍</div>
        <p>Run comparison to identify data discrepancies.</p>
      </div>
    </div>
  </div>
</div>
  `;

  const loadBtn = document.getElementById('loadBtn')!;
  const sessionFilter = document.getElementById('sessionFilter') as HTMLSelectElement;
  const classFilter = document.getElementById('classFilter') as HTMLSelectElement;
  const tableContainer = document.getElementById('comparisonTable')!;
  const syncAllBtn = document.getElementById('syncAllBtn') as HTMLButtonElement;
  const statsRow = document.getElementById('statsRow')!;
  const searchStrip = document.getElementById('searchStrip')!;
  const tableSearch = document.getElementById('tableSearch') as HTMLInputElement;
  const showOnlyMismatch = document.getElementById('showOnlyMismatch') as HTMLInputElement;

  let comparisonData: any[] = [];

  loadBtn.onclick = async () => {
    tableContainer.innerHTML = '<div class="loading-state"><p>Analyzing data records...</p></div>';
    syncAllBtn.style.display = 'none';
    statsRow.style.display = 'none';
    searchStrip.style.display = 'none';

    const session = sessionFilter.value;
    const cls = classFilter.value;

    let query = sb.from('student_database').select('*');
    if (cls) query = query.eq(`class_${session}`, cls);
    else query = query.not(`class_${session}`, 'is', null);

    const { data, error } = await query.order(`roll_${session}`);

    if (error) {
      tableContainer.innerHTML = `<div class="loading-state" style="color:red;">Error: ${error.message}</div>`;
      return;
    }

    comparisonData = data || [];
    renderTable();
    statsRow.style.display = 'grid';
    searchStrip.style.display = 'flex';
  };

  function renderTable() {
    const session = sessionFilter.value;
    const classCol = `class_${session}`;
    const sectionCol = `section_${session}`;
    const rollCol = `roll_${session}`;
    const searchQuery = tableSearch.value.toLowerCase();
    const onlyMismatch = showOnlyMismatch.checked;

    let mismatchCount = 0;
    let syncedCount = 0;

    const filtered = comparisonData.filter(s => {
      const isMismatch = s.active_class !== s[classCol] || 
                         s.active_section !== s[sectionCol] || 
                         s.active_roll !== s[rollCol];
      
      if (isMismatch) mismatchCount++;
      else syncedCount++;

      const nameMatch = s.student_name_en?.toLowerCase().includes(searchQuery) || 
                        s.iid?.toString().includes(searchQuery);
      
      if (onlyMismatch && !isMismatch) return false;
      return nameMatch;
    });

    // Sort by mismatch first
    filtered.sort((a, b) => {
      const aMismatch = a.active_class !== a[classCol] || a.active_section !== a[sectionCol] || a.active_roll !== a[rollCol];
      const bMismatch = b.active_class !== b[classCol] || b.active_section !== b[sectionCol] || b.active_roll !== b[rollCol];
      if (aMismatch === bMismatch) return 0;
      return aMismatch ? -1 : 1;
    });

    // Update Stats
    document.getElementById('statChecked')!.textContent = comparisonData.length.toString();
    document.getElementById('statMismatch')!.textContent = mismatchCount.toString();
    document.getElementById('statSynced')!.textContent = syncedCount.toString();

    if (filtered.length === 0) {
      tableContainer.innerHTML = '<div class="loading-state">No matching records found.</div>';
      return;
    }

    tableContainer.innerHTML = `
      <table>
        <thead>
          <tr>
            <th>IID / Roll</th>
            <th>Student Name</th>
            <th>Class Status</th>
            <th>Section Status</th>
            <th>Roll Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          ${filtered.map(s => {
            const isMismatch = s.active_class !== s[classCol] || 
                               s.active_section !== s[sectionCol] || 
                               s.active_roll !== s[rollCol];
            
            return `
              <tr data-iid="${s.iid}" style="${!isMismatch ? 'background: #fcfdfd;' : ''}">
                <td style="border-left: 4px solid ${isMismatch ? '#f59e0b' : '#10b981'};">
                  <div style="font-weight:800; color:#1e293b; font-size:16px;">${s.iid}</div>
                  <div style="font-size:12px; color:#64748b; font-weight:600;">${session} Roll: ${s[rollCol]}</div>
                </td>
                <td style="font-weight:700; color:#334155;">${s.student_name_en}</td>
                <td>
                  ${s.active_class === s[classCol] ? `<span class="val-match">${s[classCol]}</span>` : 
                    `<div class="diff-chip"><span class="old-val">${s.active_class || 'None'}</span><span class="new-val">${s[classCol]}</span></div>`}
                </td>
                <td>
                  ${s.active_section === s[sectionCol] ? `<span class="val-match">${s[sectionCol]}</span>` : 
                    `<div class="diff-chip"><span class="old-val">${s.active_section || 'None'}</span><span class="new-val">${s[sectionCol]}</span></div>`}
                </td>
                <td>
                  ${s.active_roll === s[rollCol] ? `<span class="val-match">${s[rollCol]}</span>` : 
                    `<div class="diff-chip"><span class="old-val">${s.active_roll || 'None'}</span><span class="new-val">${s[rollCol]}</span></div>`}
                </td>
                <td>
                  <button class="btn-sync" onclick="window.syncSingle('${s.iid}')" ${!isMismatch ? 'disabled' : ''}>
                    ${isMismatch ? 'Sync Now' : 'Synced'}
                  </button>
                </td>
              </tr>
            `;
          }).join('')}
        </tbody>
      </table>
    `;

    if (mismatchCount > 0) {
      syncAllBtn.style.display = 'block';
      syncAllBtn.textContent = `Sync ${mismatchCount} Discrepancies`;
    } else {
      syncAllBtn.style.display = 'none';
    }
  }

  tableSearch.oninput = renderTable;
  showOnlyMismatch.onchange = renderTable;

  (window as any).syncSingle = async (iid: string) => {
    const session = sessionFilter.value;
    const student = comparisonData.find(s => s.iid.toString() === iid);
    if (!student) return;

    const row = document.querySelector(`tr[data-iid="${iid}"]`)!;
    const btn = row.querySelector('.btn-sync') as HTMLButtonElement;
    btn.disabled = true;
    btn.textContent = 'Syncing...';

    const updates = {
      active_class: student[`class_${session}`],
      active_section: student[`section_${session}`],
      active_roll: student[`roll_${session}`]
    };

    const { error } = await sb.from('student_database').update(updates).eq('iid', iid);
    if (error) {
       alert('Error: ' + error.message);
       btn.textContent = 'Sync Now';
       btn.disabled = false;
    } else {
      student.active_class = updates.active_class;
      student.active_section = updates.active_section;
      student.active_roll = updates.active_roll;
      renderTable();
    }
  };

  syncAllBtn.onclick = async () => {
    const session = sessionFilter.value;
    const toUpdate = comparisonData.filter(s => 
      s.active_class !== s[`class_${session}`] || 
      s.active_section !== s[`section_${session}`] || 
      s.active_roll !== s[`roll_${session}`]
    );

    if (toUpdate.length === 0) return;
    if (!confirm(`Are you sure you want to sync ${toUpdate.length} records?`)) return;

    syncAllBtn.disabled = true;
    syncAllBtn.textContent = 'Processing...';

    for (const s of toUpdate) {
      const { error } = await sb.from('student_database').update({
        active_class: s[`class_${session}`],
        active_section: s[`section_${session}`],
        active_roll: s[`roll_${session}`]
      }).eq('iid', s.iid);
      
      if (!error) {
        s.active_class = s[`class_${session}`];
        s.active_section = s[`section_${session}`];
        s.active_roll = s[`roll_${session}`];
      }
    }

    syncAllBtn.disabled = false;
    renderTable();
    alert('Sync completed successfully.');
  };
}
